import axios from "axios";
export const getAllContents = () => {
  return axios.request({
    url: "api/remote/gcHelper/contentCategory/allContents",
    method: "get"
  });
};
export const generateFwhlAuthCode = () => {
  return axios.request({
    url: "/api/app/generateFwhlAuthCode",
    method: "post"
  });
};